<template>
  <ContractStatus>
    <template #default="{}">
      <v-row no-gutters>
        <v-card-title class="font--m-5 pa-4"
          >송금 가능 금액
          <v-tooltip v-model="toolTipShow" top>
            <template v-slot:activator="{}">
              <v-btn
                small
                icon
                @click="toolTipShow = !toolTipShow"
                id="btn__GJ7zfGz6hkusjMIIogxQ/A=="
              >
                <v-icon small>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            연동한 플랫폼의 주문 내역, 주문 취소율 등을 종합적으로 고려하여 산출됩니다.<br />
            tip) 최대한 많은 플랫폼 연동 시 해당 금액은 상향 될 수 있습니다.
          </v-tooltip>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-actions class="pa-4"
          ><v-btn
            algin="right"
            icon
            @click="getAvailableAmount()"
            id="btn__itvSr3rXU0ud+ArgYhmoKA=="
          >
            <v-icon class="toggleUpDown" :class="{ rotate: getAvailableAmountLoading }"
              >mdi-refresh</v-icon
            ></v-btn
          >
        </v-card-actions>
        <v-card-text
          class="text-center color--buynow pa-4"
          style="font-size: 32px; font-weight: 900"
        >
          {{ displayAvailableAmount | commaFormat }}원
        </v-card-text>
        <v-card-text class="text-center font--m-5 pa-4" v-if="displayAvailableAmount === 0">
          아쉽게도 사용 가능한 금액이 없어요
          <v-icon small color="yellow">mdi-alert-circle</v-icon>
        </v-card-text>
        <v-card-text
          class="text-right color--gray-80 font--m-4 pa-4 pt-2"
          v-if="isServiceAvailable && !isAllCompleted"
        >
          총 {{ availableAmount.limitBeforeDiscount | commaFormat }}원 중
          <v-btn
            small
            icon
            @click="isThirtyPercentLimit()"
            class="ml-0 mb-1"
            id="btn__4n/9FQ9Kkk6lZAlQFBbBLg=="
          >
            <v-icon color="yellow">mdi-chevron-right-circle</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-text class="text-center font--m-5 pa-4" v-if="!isServiceAvailable">
          계약서 작성 완료 후 송금이 진행됩니다.
          <v-icon small color="yellow">mdi-alert-circle</v-icon>
        </v-card-text>
      </v-row>
    </template>
  </ContractStatus>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { commaFormat } from '@/filter/number'
import ContractStatus from '@/components/main/status/ContractStatus.vue'

export default {
  components: {
    ContractStatus,
  },
  computed: {
    ...mapState('bnpl', [
      'availableAmount',
      'wrongCredentials',
      'is2faRequireds',
      'getAvailableAmountLoading',
    ]),
    ...mapGetters('contract', [
      'isServiceAvailable',
      'isPending',
      'isAllCompleted',
      'isServiceAvailable',
    ]),
    ...mapGetters('mall', ['providersObj', 'mallsObj']),
    isService() {
      return this.isServiceAvailable
    },
    calculatePercent() {
      return (this.availableAmount.available * 100) / this.availableAmount.limitBeforeDiscount
    },
    calculateAmount() {
      const { limitBeforeDiscount, available, used } = this.availableAmount
      const result = limitBeforeDiscount - available - used
      // 연동 계약서 작성 후 늘어날 예정 금액이 음수면 0원으로 표기
      return result > 0 ? result : 0
    },
    displayAvailableAmount() {
      const { available, limit, limitBeforeDiscount } = this.availableAmount
      if (!this.isServiceAvailable) {
        /**
         * 완료인 거 하나도 없음
            양도 완료 기준 한도를 보여 줌
         */
        return limitBeforeDiscount
      }
      // else if (!this.isAllCompleted) {
      //   /**
      //    * 작은숫자
      //    */
      //   return limit < available ? limit : available
      // }
      return available
    },
    today() {
      return this.$moment(Date.now()).format('MM.DD')
    },
    availableContractsName() {
      if (Object.keys(this.providersObj).length === 0) {
        return
      }
      const result = this.isPending
        .filter((v) => this.providersObj[v.mallProviderCode].isAvailable) // filter 먼저
        .map((v) => {
          return this.providersObj[v.mallProviderCode].name // providersObj 이름 리스트 뱉어내기
        })
      return result
    },
  },
  data() {
    return {
      toolTipShow: false,
    }
  },
  async created() {},
  methods: {
    async getAvailableAmount() {
      this.$emit('refresh')
    },
    async isThirtyPercentLimit() {
      const confirm = await this.$swal.basic.alert({
        html: `<p class="font--m-3">양도통지 필요</p><br /><p><strong class="color--buynow">${
          this.availableContractsName
        }</strong> 플랫폼에 채권양도 통지가 완료되면 <br /> <strong class="color--buynow">${commaFormat(
          this.calculateAmount,
        )}</strong>원의 송금 가능 금액이 늘어나요! <br /> (${this.today}일 기준)</p><br /><br />`,
        icon: 'warning',
        iconColor: '#FFD233',
        showCloseButton: false,
        showConfirmButton: true,
        confirmButtonText: '채권양도 바로가기',
      })
      if (confirm.isConfirmed === true) {
        return this.$router.push({ name: 'my/contract/management' })
      }
    },
  },
}
</script>

<style>
.toggleUpDown {
  transition: transform 0.3s ease-in-out !important;
}

.toggleUpDown.rotate {
  animation: rotate 1s infinite;
}

@keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
